import styled from "styled-components";
export const TRANSITION_TIME = 400;
const getExitLeft = (direction) => (direction === "left-to-right" ? "-100%" : "100%");
export const getTransitionStyles = ({ direction, transitionStatus }) => {
    switch (transitionStatus) {
        case "entering":
            return { left: "0" };
        case "entered":
            return { left: "0" };
        case "exiting":
            return { left: getExitLeft(direction) };
        case "exited":
            return { left: getExitLeft(direction) };
        default:
            return {};
    }
};
export const AnimatedPanelOuter = styled.div `
  height: 100%;
  width: ${({ width }) => width};
  position: relative;
  overflow: hidden;
`;
AnimatedPanelOuter.displayName = "AnimatedPanelOuter";
export const AnimatedPanelInner = styled.div `
  height: 100%;
  position: absolute;
  transition: left ${({ time }) => time}ms ease-in-out;
  left: 0;
  padding: ${({ dropShadowElevationPadding }) => dropShadowElevationPadding}px;
`;
